import { BondApiUrls } from "@/modules/bond/common/enum";
import type { BondsResponse, IBondsRequest } from "@/modules/bond/common/types";
import { generateQuery } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const bondApi = createApi({
  reducerPath: "bondApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getBonds: builder.query<BondsResponse, IBondsRequest>({
      query: ({ pageSize }) => {
        const query = generateQuery({ pageSize });
        const url = `${BondApiUrls.Bonds}?${query}`;
        return { url };
      },
    }),
  }),
});

export const { useGetBondsQuery } = bondApi;
